import types from "./types";

const initialState = {
  teamMatesList: {},
  reaReportList: {},
  courseReportList: {},
  managerReportList: {},
  providerReportList: {},
  current_view: 1,
  joyRideRes: {},
  showDropDownRes:false,
  showMoreMenuRes:false,
  assignTeamMates: {},
  officeList: {},
  completedCourseList: {},
  usersByOfficeList: {},
  teamsList: {},
  assignTeamsRes: {},
  assignedUsers: {},
  congrat_class_name: "step1",
  chooseLpPath: {},
  assignUserList: {},
  changeDueDate: {},
  categoryListByEntityId: {},
  availableLPByEntityId: {},
  brokerageFilterList: []
};

export default (state = initialState, action) => {
  switch (action.type) {
    case types.GET_TEAMMATES_RESPONSE:
      return {
        ...state,
        teamMatesList: action.payload,
      };
    case types.GET_TEAMMATES_RESPONSE_CLEAR:
      return {
        ...state,
        teamMatesList: {},
      };
    case types.GET_REA_LIST_REPORT_RESPONSE:
      return {
        ...state,
        reaReportList: action.payload,
      };
    case types.GET_REA_LIST_REPORT_RESPONSE_CLEAR:
      return {
        ...state,
        reaReportList: {},
      };
    case types.GET_COURSE_LIST_REPORT_RESPONSE:
      return {
        ...state,
        courseReportList: action.payload,
      };
    case types.GET_COURSE_LIST_REPORT_RESPONSE_CLEAR:
      return {
        ...state,
        courseReportList: {},
      };
    case types.GET_MANAGER_LIST_REPORT_RESPONSE:
      return {
        ...state,
        managerReportList: action.payload,
      };
    case types.GET_MANAGER_LIST_REPORT_RESPONSE_CLEAR:
      return {
        ...state,
        managerReportList: {},
      };
    case types.GET_PROVIDER_LIST_REPORT_RESPONSE:
      return {
        ...state,
        providerReportList: action.payload,
      };
    case types.GET_PROVIDER_LIST_REPORT_RESPONSE_CLEAR:
      return {
        ...state,
        providerReportList: {},
      };
    case types.CURRENT_VIEW:
      return {
        ...state,
        current_view:
          action.payload === undefined ? state.current_view : action.payload,
      };
    case types.JOY_RIDE:
      return {
        ...state,
        joyRideRes: action.payload === undefined ? state.joyRideRes : action.payload,
      };
      case types.SHOW_DROPDOWN:
      return {
        ...state,
        showDropDownRes: action.payload === undefined ? state.showDropDownRes : action.payload,
      };
      case types.SHOW_MORE_MENU:
      return {
        ...state,
        showMoreMenuRes: action.payload === undefined ? state.showMoreMenuRes : action.payload,
      };
    case types.GET_CLASS:
      return {
        ...state,
        congrat_class_name:
          action.payload === undefined ? state.congrat_class_name : action.payload,
      };
    case types.ASSIGN_TEAMMATES_RESPONSE:
      return {
        ...state,
        assignTeamMates: action.payload,
      };
    case types.ASSIGN_TEAMMATES_RESPONSE_CLEAR:
      return {
        ...state,
        assignTeamMates: {},
      };
    case types.SEARCH_OFFICE_LIST_RESPONSE:
      return {
        ...state,
        officeList: action.payload,
      };
    case types.SEARCH_OFFICE_LIST_RESPONSE_CLEAR:
      return {
        ...state,
        officeList: {},
      };
    case types.COMPLETED_COURSE_LIST_RESPONSE:
      return {
        ...state,
        completedCourseList: action.payload,
      };
    case types.COMPLETED_COURSE_LIST_RESPONSE_CLEAR:
      return {
        ...state,
        completedCourseList: {},
      };
    case types.GET_USERS_BY_OFFICE_LIST_RESPONSE:
      return {
        ...state,
        usersByOfficeList: action.payload,
      };
    case types.GET_USERS_BY_OFFICE_LIST_CLEAR:
      return {
        ...state,
        usersByOfficeList: {},
      };
    case types.GET_TEAMS_LIST_RES:
      return {
        ...state,
        teamsList: action.payload,
      };
    case types.GET_TEAMS_LIST_RES_CLEAR:
      return {
        ...state,
        teamsList: {},
      };
    case types.ASSIGN_TO_TEAMS_RES:
      return {
        ...state,
        assignTeamsRes: action.payload,
      };
    case types.ASSIGN_TO_TEAMS_RES_CLEAR:
      return {
        ...state,
        assignTeamsRes: {},
      };
    case types.GET_ASSIGN_USERS_RES:
      return {
        ...state,
        assignedUsers: action.payload,
      };
    case types.GET_ASSIGN_USERS_RES_CLEAR:
      return {
        ...state,
        assignedUsers: {},
      };
    //Filter LP Report
    case types.CHOOSE_LP_REPORT_FILTER_RES:
      return {
        ...state,
        chooseLpPath: action.payload,
      };
    case types.CHOOSE_LP_REPORT_FILTER_CLEAR:
      return {
        ...state,
        chooseLpPath: {},
      };
    case types.GET_ASSIGN_USER_LIST_RES:
      return {
        ...state,
        assignUserList: action.payload,
      };
    case types.GET_ASSIGN_USER_LIST_CLEAR:
      return {
        ...state,
        assignUserList: {},
      };
    case types.CHANGE_DUE_DATE_ASSIGN_USER_LIST_RES:
      return {
        ...state,
        changeDueDate: action.payload,
      };
    case types.CHANGE_DUE_DATE_ASSIGN_USER_LIST_CLEAR:
      return {
        ...state,
        changeDueDate: {},
      };
    case types.GET_CATEGORY_BY_ENTITY_ID_RES:
      return {
        ...state,
        categoryListByEntityId: action.payload,
      };
    case types.GET_CATEGORY_BY_ENTITY_ID_CLEAR:
      return {
        ...state,
        categoryListByEntityId: {},
      };
    case types.AVAILABLE_LP_BY_ENTITY_ID_RES:
      return {
        ...state,
        availableLPByEntityId: action.payload,
      };
    case types.AVAILABLE_LP_BY_ENTITY_ID_CLEAR:
      return {
        ...state,
        availableLPByEntityId: {},
      };
    case types.GET_BROKERAGE_FILTER_LIST_REQ_RESPONSE:
      return {
        ...state,
        brokerageFilterList: action.payload,
      };
    case types.GET_BROKERAGE_FILTER_LIST_REQ_CLEAR:
      return {
        ...state,
        brokerageFilterList: {},
      };
    default:
      return state;
  }
};
